import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { FlaskConical, Loader2 } from "lucide-react";

const eur = (n) => (n == null ? "—" : new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n));

export default function ProductsUsedHistory() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/products/usage-history").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  const n = (s) => (s || "").toLowerCase();
  const list = (rows || []).filter((r) => !q || n(r.product).includes(n(q)) || n(r.brand).includes(n(q)) || n(r.client).includes(n(q)));
  return (
    <div className="max-w-6xl mx-auto" data-testid="products-used-history">
      <PageHeader title="Produits utilisés" subtitle="Historique des consommations réelles saisies dans les dossiers atelier" icon={FlaskConical} />
      {rows === null ? <Loader2 className="w-6 h-6 animate-spin text-emerald-600" /> : rows.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-xl p-8 text-center" data-testid="puh-empty">
          <p className="text-sm text-slate-600">Aucun produit utilisé enregistré pour le moment.</p>
          <Link to="/calendar" className="inline-block mt-3 text-sm text-emerald-700 underline" data-testid="puh-go-appts">Accéder aux rendez-vous / dossiers atelier</Link>
        </div>
      ) : (
        <>
          <input data-testid="puh-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un produit, une marque, un client…" className="w-full sm:w-80 mb-4 rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm" />
          <div className="space-y-2">
            {list.map((r, i) => (
              <div key={i} className="bg-white border border-slate-200 rounded-xl p-4 grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-2" data-testid="puh-row">
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-slate-900 break-words">{[r.brand, r.product].filter(Boolean).join(" — ")}{r.manual ? " (saisie manuelle)" : ""}</div>
                  <div className="text-xs text-slate-500">{r.date ? new Date(r.date).toLocaleDateString("fr-FR") : ""} · {r.client || "—"}{r.vehicle ? ` · ${r.vehicle}` : ""}{r.services?.length ? ` · ${r.services.join(", ")}` : ""}</div>
                  <div className="text-xs text-slate-500">{r.subcategory || ""}{r.dilution ? ` · dilution ${r.dilution}` : ""}{r.step ? ` · ${r.step}` : ""}</div>
                </div>
                <div className="text-xs text-slate-700 sm:text-right">
                  <div>Solution utilisée : <b>{r.solution_ml} ml</b></div>
                  <div>Concentré : <b>{r.concentrate_ml} ml</b></div>
                  {r.cost !== undefined && r.cost !== null && <div>Coût interne : <b>{eur(r.cost)}</b></div>}
                  <Link to={`/rdv/${r.appointment_id}/atelier?tab=produits`} className="text-emerald-700 underline">Dossier atelier</Link>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
